import React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react';

function SingleInputShimmer() {
  const shimmerStyle1 = { root: { marginBottom: '8px' } };
  const shimmerStyle2 = { root: { marginBottom: '20px' } };
  const elements = [
    { type: ShimmerElementType.line, height: 32 },
  ];

  return (
    <React.Fragment>
      <Shimmer width="60%" styles={shimmerStyle1} />
      <Shimmer shimmerElements={elements} styles={shimmerStyle2} />
    </React.Fragment>
  );
}

export function PromotionalOfferViewShimmer() {
  return (
    <React.Fragment>
      <SingleInputShimmer />
    </React.Fragment>
  );
}
